var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWtsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 905,
    height: 905,
    viewBox: "0 0 905 905",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 905,
    height: 905,
    rx: 160,
    fill: "#3B82F6",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 82,
    width: 741,
    height: 741,
    rx: 100,
    fill: "#3B82F6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_830_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.425 308.733C574.904 290.04 552.847 275.22 528.54 265.136C504.234 255.053 478.163 249.908 451.848 250.001C341.582 250.001 251.717 339.841 251.616 450.133C251.616 485.457 260.858 519.823 278.305 550.249L250 654.001L356.151 626.176C385.517 642.157 418.416 650.533 451.848 650.542H451.95C562.242 650.542 652.081 560.702 652.182 450.309C652.207 424 647.026 397.946 636.938 373.647C626.849 349.349 612.078 327.287 593.425 308.733ZM451.848 616.656C422.028 616.667 392.756 608.642 367.11 593.426L361.049 589.79L298.076 606.304L314.892 544.871L310.954 538.533C294.284 512.029 285.467 481.342 285.527 450.032C285.527 358.475 360.191 283.786 451.95 283.786C473.809 283.747 495.461 288.035 515.656 296.403C535.851 304.771 554.189 317.054 569.614 332.543C585.094 347.972 597.365 366.313 605.72 386.509C614.076 406.704 618.35 428.353 618.297 450.208C618.196 542.093 543.531 616.656 451.848 616.656ZM543.127 492.073C538.153 489.573 513.585 477.479 508.964 475.762C504.368 474.12 501.01 473.262 497.728 478.261C494.369 483.236 484.775 494.573 481.896 497.83C479.018 501.188 476.038 501.567 471.038 499.092C466.064 496.567 449.93 491.316 430.841 474.221C415.943 460.965 405.969 444.552 402.99 439.578C400.111 434.579 402.712 431.902 405.212 429.402C407.408 427.18 410.186 423.544 412.686 420.666C415.211 417.787 416.044 415.666 417.685 412.333C419.326 408.95 418.544 406.071 417.306 403.572C416.044 401.072 406.07 376.403 401.853 366.454C397.813 356.632 393.698 357.995 390.617 357.869C387.739 357.692 384.381 357.692 381.022 357.692C378.486 357.756 375.991 358.342 373.692 359.415C371.393 360.489 369.341 362.025 367.665 363.929C363.069 368.929 350.217 381.023 350.217 405.693C350.217 430.362 368.145 454.072 370.67 457.43C373.144 460.788 405.868 511.263 456.09 532.978C467.958 538.154 477.301 541.21 484.598 543.533C496.592 547.371 507.424 546.79 516.059 545.553C525.654 544.088 545.627 533.433 549.844 521.742C553.985 510.026 553.985 500.027 552.722 497.931C551.485 495.81 548.127 494.573 543.127 492.073Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_830_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 404,
    height: 404,
    fill: "white",
    transform: "translate(250 250)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWtsapp);
export default __webpack_public_path__ + "static/media/wtsapp.70858083eef780ad810fcc858eb81826.svg";
export { ForwardRef as ReactComponent };